import { filterStores } from '../../state';
import type {
	FilterDrawerCollectionRestrictedValues,
	FilterDrawerState,
	FilterDrawerTouchedItems
} from '../../types';

export function setFilterCollectionValue<T extends FilterDrawerCollectionRestrictedValues>({
	filterCollectionId,
	value
}: {
	filterCollectionId: string;
	value: T | null | undefined;
}) {
	if (value === null || value === undefined) return;

	const { filterStore, touchedItemsStore } = filterStores;

	touchedItemsStore.update((touchedItems: FilterDrawerTouchedItems) => {
		return {
			...touchedItems,
			[filterCollectionId]: true
		};
	});

	filterStore.update((filter: FilterDrawerState) => {
		return {
			...filter,
			[filterCollectionId]: {
				...filter[filterCollectionId],
				value
			}
		};
	});
}
